import { useSelector } from 'react-redux'
import { authSlice } from '../../../authSlice'
import { SignUpStages } from '../SignUpStages'
import { Clock2 } from 'lucide-react'

export const ApprovalPendingBlock = () => {
  const signupFields = useSelector(authSlice.selectors.selectSignupFields)

  return (
    <div className="mx-auto flex w-[450px] flex-col items-center">
      <SignUpStages position={3} />
      <div className="my-m flex flex-col items-center gap-xxs pt-m text-center">
        <Clock2 size={48} className="text-gray-400" />
        <h1 className="text-lg font-semibold text-gray-900">
          Your account is pending approval
        </h1>
        <div className="text-base font-medium text-gray-500">
          when your account is approved by this server&rsquo;s admin,
          you&rsquo;ll receive a notification on the{' '}
          <span className="text-gray-900">{signupFields?.email || ''}</span>
        </div>
      </div>
    </div>
  )
}
